import { CONTAINER_MODULE_MAP } from './constant';
import type { SentryModule } from './types';

export { CONTAINER_MODULE_MAP } from './constant';

export const moduleFromContainerName = (
  componentName?: string | null,
): SentryModule | undefined =>
  componentName ? CONTAINER_MODULE_MAP[componentName] : undefined;
